var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.5V18M15 7.5V18M3 16.811V8.69C3 7.826 3.933 7.284 4.683 7.713L11.791 11.774C11.9633 11.8724 12.1065 12.0146 12.2062 12.1861C12.3058 12.3577 12.3582 12.5526 12.3582 12.751C12.3582 12.9494 12.3058 13.1443 12.2062 13.3159C12.1065 13.4874 11.9633 13.6296 11.791 13.728L4.683 17.789C4.51182 17.8868 4.31796 17.9379 4.12082 17.9371C3.92369 17.9364 3.73021 17.8839 3.55976 17.7848C3.38932 17.6858 3.24789 17.5437 3.14965 17.3728C3.05141 17.2019 2.9998 17.0081 3 16.811Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrowForward.c40396141bfcba9799afabb3bb1d8eec.svg";
export { ForwardRef as ReactComponent };